import {STAGE_ACCOUNTS, STAGE_BUSINESS_UNIT, STAGE_CLIENT, STAGE_GOALS, STAGE_SCHEDULE} from './materializeLine';

/**
 * El copy de cada error del wizard, resuelto por CÓDIGO y nunca con el `error_message` crudo: ése
 * puede ser el `detail` en inglés de DRF, un relleno del propio `APIClient` o un texto que nombra a
 * otra agencia.
 *
 * Los códigos conocidos dicen qué corregir; el resto cae al genérico de la etapa, que dice qué NO se
 * pudo hacer y que lo anterior ya quedó guardado (el reintento retoma desde ahí).
 */

const CODE_KEYS = {
    CANT_ADD_MORE_AD_ACCOUNTS: 'line_wizard.error.cant_add_more_accounts',
    ACCOUNTS_NOT_FOUND: 'line_wizard.error.accounts_not_found',
    ERROR_CONDITION_TO_INCLUDE_CAMPAIGNS_INVALID: 'line_wizard.error.condition_invalid',
    ERROR_AT_LEAST_ONE_CAMPAIGN: 'line_wizard.error.at_least_one_campaign',
    ERROR_AT_LEAST_ONE_ADGROUP: 'line_wizard.error.at_least_one_campaign',
    METRIC_NOT_AVAILABLE_IN_PLATFORM: 'goal_configuration.metric_not_available_error',
    NETWORK_ERROR: 'line_wizard.error.network',
};

const STAGE_KEYS = {
    [STAGE_CLIENT]: 'line_wizard.error.stage_client',
    [STAGE_BUSINESS_UNIT]: 'line_wizard.error.stage_business_unit',
    [STAGE_SCHEDULE]: 'line_wizard.error.stage_schedule',
    [STAGE_GOALS]: 'line_wizard.error.stage_goals',
    [STAGE_ACCOUNTS]: 'line_wizard.error.stage_accounts',
};

export function codeOf(response) {
    if (!response) return null;
    return response.error_code || response.status || null;
}

export function errorMessageForCode(t, response, fallbackKey) {
    const key = CODE_KEYS[codeOf(response)];
    return t(key || fallbackKey);
}

export function materializeErrorMessage(t, result) {
    return errorMessageForCode(t, result.response, STAGE_KEYS[result.stage] || 'line_wizard.error.generic');
}
